import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectIsResetOpen } from "../reduxSlices/resetToggleSlice";
import { applyBackgroundColor, applyTextColor } from "../host/actions";

function ColorPreview({
  color,
  previewColors,
  setPreviewColors,
  setIsRemoveButtonClicked,
  onApply,
}) {
  const { t } = useTranslation();
  const isResetOpen = useSelector(selectIsResetOpen);

  useEffect(() => {
    const stored = localStorage.getItem("colorSliderValues");
    if (!stored) return;

    try {
      const parsed = JSON.parse(stored);

      setPreviewColors((prev) => ({
        ...prev,
        backgroundColor: parsed?.backgroundColor || "#000000",
        textColor: parsed?.textColor || "#ffffff",
      }));

      if (parsed?.backgroundColor) {
        applyBackgroundColor(parsed.backgroundColor);
      }

      if (parsed?.textColor) {
        applyTextColor(parsed.textColor);
      }
    } catch (error) {
      console.error("Failed to restore color slider values", error);
    }
  }, [setPreviewColors]);

  useEffect(() => {
    if (!isResetOpen) return;

    setPreviewColors({
      backgroundColor: "#000000",
      textColor: "#ffffff",
    });

    localStorage.removeItem("colorSliderValues");

    applyBackgroundColor("");
    applyTextColor("");
  }, [isResetOpen, setPreviewColors]);

  const handleApply = () => {
    onApply?.();

    applyBackgroundColor(previewColors?.backgroundColor || "");
    applyTextColor(previewColors?.textColor || "");
  };

  const handleRemove = () => {
    setPreviewColors({
      backgroundColor: "#000000",
      textColor: "#ffffff",
    });

    setIsRemoveButtonClicked((prev) => !prev);

    localStorage.removeItem("colorSliderValues");

    applyBackgroundColor("");
    applyTextColor("");
  };

  return (
    <div className="w-full mt-[0.94rem]">
      <div className="rounded-[0.75rem] border-[0.063rem] border-inner-widget-border p-[0.75rem]">
        <div
          className="rounded-[0.5rem] px-[1rem] py-[0.875rem] text-center text-[0.875rem] font-[500] leading-[1.25rem]"
          style={{
            backgroundColor: previewColors?.backgroundColor || "#000000",
            color: previewColors?.textColor || "#ffffff",
          }}
        >
          {t("Color Preview")}
        </div>

        <div className="flex gap-[0.63rem] mt-[0.75rem]">
          <button
            onClick={handleApply}
            className="flex-1 h-[2.5rem] rounded-[0.5rem] text-white font-medium hover:opacity-90"
            style={{
              background: color?.includes("linear-gradient")
                ? color
                : undefined,
              backgroundColor: !color?.includes("linear-gradient")
                ? color
                : undefined,
            }}
          >
            {t("Apply")}
          </button>

          <button
            onClick={handleRemove}
            className="flex-1 h-[2.5rem] rounded-[0.5rem] border border-[#1212121A] text-[#121212] font-medium hover:bg-gray-100"
          >
            {t("Remove")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ColorPreview;
